import preval from 'preval.macro'

export const getVersion = () => {
    return 'Versión ' + preval`module.exports = new Date().toLocaleString();`
}